import { render, staticRenderFns } from "./stickyCard.vue?vue&type=template&id=151dff04&"
import script from "./stickyCard.vue?vue&type=script&lang=js&"
export * from "./stickyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports